import { render } from "./CajaChica.vue?vue&type=template&id=6b39d2ec&scoped=true"
import script from "./CajaChica.vue?vue&type=script&lang=js"
export * from "./CajaChica.vue?vue&type=script&lang=js"

import "./CajaChica.vue?vue&type=style&index=0&id=6b39d2ec&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b39d2ec"]])

export default __exports__